/**
 * Code ownership: Slide & Live
 */

export type PresentationTypography = object;

export const presentationTypography: PresentationTypography = {};
